import React, { useContext, useEffect } from 'react';
import { FactContext } from '../context/FactContext';
import Navbar from '../components/navbar';

const Admin = () => {
    const { connectWallet, currentAccount, isWalletOwner, isOwner } = useContext(FactContext);
    const status = {
        NO_WALLET: "no_wallet",
        IS_OWNER: "is_owner",
        IS_NOT_OWNER: "is_not_owner",
        ERROR: "error"
    }

    useEffect(() => {
        if(currentAccount) {
            isWalletOwner();
        }
    }, []);

    const buildUIForState = state => {
        if(state == status.NO_WALLET) {
            return (
                <button 
                    className="contract-button" 
                    onClick={connectWallet}>
                    {'Connect Wallet'}
                </button>
            );
        } else if(state == status.IS_NOT_OWNER) {
            return (
                <div className='admin-text'>
                    <p>You are not the owner</p>
                </div>
            )
        } else if(state == status.IS_OWNER) {
            return (
                <div className='admin-text'>
                    <p>Welcome to the admin portal</p>
                </div>
            )
        } else {
            return (
                <p className='admin-text'>{'Something went wrong!'}</p>
            )
        }
    }

    const getState = () => {
        if(!currentAccount) {
            return status.NO_WALLET;
        } else if(currentAccount) {
            if(!isOwner) {
                return status.IS_NOT_OWNER;
            } else {
                return status.IS_OWNER;
            }
        } else {
            return status.ERROR;
        }
    }

    return (
        <div className="main">
            <Navbar></Navbar>
            <div className="title-box">
                {buildUIForState(getState())}
            </div>
        </div>
    );
}
  
export default Admin;